if (!customElements.get("store-locator-section")) {
  class StoreLocatorSection extends HTMLElement {
    constructor() {
      super();
      this.currentPage = 1;
      this.currentDistrict = "all";
    }

    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll("[data-store-card]"));
      this.filter = this.querySelector("[data-store-district-filter]");
      this.selectWrapper = this.querySelector(".tiendas-ilahui__select-wrapper");
      this.emptyState = this.querySelector("[data-store-empty]");
      this.pagination = this.querySelector("[data-store-pagination]");
      this.cardsPerPage = parseInt(this.dataset.cardsPerPage, 10) || 6;

      if (this.filter) {
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onFilterFocus = this.onFilterFocus.bind(this);
        this.onFilterBlur = this.onFilterBlur.bind(this);
        this.onFilterPointerDown = this.onFilterPointerDown.bind(this);
        this.filter.addEventListener("change", this.onFilterChange);
        this.filter.addEventListener("focus", this.onFilterFocus);
        this.filter.addEventListener("blur", this.onFilterBlur);
        this.filter.addEventListener("pointerdown", this.onFilterPointerDown);
      }

      this.update();
    }

    disconnectedCallback() {
      if (this.filter && this.onFilterChange) {
        this.filter.removeEventListener("change", this.onFilterChange);
        this.filter.removeEventListener("focus", this.onFilterFocus);
        this.filter.removeEventListener("blur", this.onFilterBlur);
        this.filter.removeEventListener("pointerdown", this.onFilterPointerDown);
      }
    }

    onFilterChange(event) {
      this.currentDistrict = event.target.value || "all";
      this.currentPage = 1;
      this.closeSelectState();
      this.update();
    }

    onFilterFocus() {
      if (this.selectWrapper) {
        this.selectWrapper.classList.add("is-focused");
      }
    }

    onFilterBlur() {
      window.setTimeout(() => {
        this.closeSelectState();
      }, 120);
    }

    onFilterPointerDown() {
      if (this.selectWrapper) {
        this.selectWrapper.classList.toggle("is-open");
      }
    }

    getFilteredCards() {
      if (this.currentDistrict === "all") {
        return this.cards;
      }
      return this.cards.filter(
        (card) => (card.dataset.district || "") === this.currentDistrict
      );
    }

    closeSelectState() {
      if (this.selectWrapper) {
        this.selectWrapper.classList.remove("is-open");
        this.selectWrapper.classList.remove("is-focused");
      }
    }

    renderPagination() {
      if (!this.pagination) return;

      this.pagination.innerHTML = "";

      if (this.filteredCardsCount === 0 || this.totalPages <= 1) {
        this.pagination.hidden = true;
        return;
      }

      this.pagination.hidden = false;

      for (let page = 1; page <= this.totalPages; page += 1) {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "tiendas-ilahui__pagination-button";
        button.textContent = page;
        button.setAttribute("aria-label", `Ir a la pagina ${page}`);

        if (page === this.currentPage) {
          button.classList.add("is-active");
          button.setAttribute("aria-current", "page");
        }

        button.addEventListener("click", () => {
          if (this.currentPage !== page) {
            this.currentPage = page;
            this.update();
          }
        });

        this.pagination.appendChild(button);
      }
    }

    update() {
      const filteredCards = this.getFilteredCards();
      const totalCards = filteredCards.length;
      this.filteredCardsCount = totalCards;

      this.totalPages = Math.max(1, Math.ceil(totalCards / this.cardsPerPage));
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }

      const startIndex = (this.currentPage - 1) * this.cardsPerPage;
      const endIndex = startIndex + this.cardsPerPage;
      const visibleCards = filteredCards.slice(startIndex, endIndex);

      this.cards.forEach((card) => {
        card.hidden = !visibleCards.includes(card);
      });

      if (this.emptyState) {
        this.emptyState.hidden = totalCards !== 0;
      }

      this.renderPagination();
    }
  }

  customElements.define("store-locator-section", StoreLocatorSection);
}